function mapFields (arr) {
  return arr.map(item => {
      return {
          key: item.key,
          label: item.label,
          description: item.description,
          type: item.type,
          subType: item.subType || null,
          subForm: item.subForm,
          children: item.children && item.children.length ? mapFields(item.children) : []
      }
  })
}

export default mapFields


// WEBPACK FOOTER //
// ./src/helpers/map-fields.js